import { render, staticRenderFns } from "./ObstacleTrainerCard.vue?vue&type=template&id=2178b124&scoped=true"
import script from "./ObstacleTrainerCard.vue?vue&type=script&lang=js"
export * from "./ObstacleTrainerCard.vue?vue&type=script&lang=js"
import style0 from "./ObstacleTrainerCard.vue?vue&type=style&index=0&id=2178b124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2178b124",
  null
  
)

export default component.exports